const i18n_fields = {
  EN: [
    { key: 'item_purchased_date', thStyle: 'width: 15%', sortable: false, label: 'No.' },
    { key: 'item_company', sortable: false, label: 'Company' },
    { key: 'item_action', thStyle: 'width: 30%', sortable: false, label: 'Action'},
    { key: 'item_method', thStyle: 'width: 15%', sortable: false, label: 'Method'},
    { key: 'item_price', thStyle: 'width: 10%', sortable: false, label: 'Price' },
    { key: 'item_currency', thStyle: 'width: 10%', sortable: false, label: 'Currency' },
    { key: 'item_country', sortable: false, label: 'Country' },
  ],
  KO: [
    { key: 'item_purchased_date', thStyle: 'width: 15%', sortable: false, label: 'No.' },
    { key: 'item_company', sortable: false, label: '회사명' },
    { key: 'item_action', thStyle: 'width: 30%', sortable: false, label: '액션'},
    { key: 'item_method', thStyle: 'width: 15%', sortable: false, label: '메소드'},
    { key: 'item_price', thStyle: 'width: 10%', sortable: false, label: '가격' },
    { key: 'item_currency', thStyle: 'width: 10%', sortable: false, label: 'Currency' },
    { key: 'item_country', sortable: false, label: '국가' },
  ],
  JP: [
    { key: 'item_purchased_date', thStyle: 'width: 15%', sortable: false, label: 'No.' },
    { key: 'item_company', sortable: false, label: 'Company' },
    { key: 'item_action', thStyle: 'width: 30%', sortable: false, label: 'Action'},
    { key: 'item_method', thStyle: 'width: 15%', sortable: false, label: 'Method'},
    { key: 'item_price', thStyle: 'width: 10%', sortable: false, label: 'Price' },
    { key: 'item_currency', thStyle: 'width: 10%', sortable: false, label: 'Currency' },
    { key: 'item_country', sortable: false, label: 'Country' },
  ]
}

const fields = { i18n_fields }

export default fields